import { createEntityAdapter } from '@reduxjs/toolkit'
import { CostCentre } from 'src/types/CostCentre'
import { RootState } from '../store'

export const costCentresAdapter = createEntityAdapter({
  selectId: (costCentre: CostCentre) => costCentre.cost_centre_guid,
})

export const costCentresSelectors = costCentresAdapter.getSelectors<RootState>(
  (state) => state.costCentres,
)
